import React, { useState, useEffect } from "react";
import api from "../../Services/api";
import PageDescriptionFootnote from "../Footnote";

const PageDescriptionPlano = (props: any) => {

    const [page, setLayoutPagina] = useState<any[]>([]);

    useEffect(() => {
        api
            .get("/ObterLayoutPaginaFiltro?Identificador=" + props.page)

            .then((response) => {

                setLayoutPagina(response.data.results);
            })
            .catch((err) => {

                throw new Error(err);
            });
    }, [props.page]);

    var RMA = document.querySelector("#RMA");
    var MAT = document.querySelector("#MAT");
    var VITALICIO = document.querySelector("#VITALICIO");
    function renderObjectBody(data: any) {
        return { __html: data }
    }
    return (

        <section className="page-description pt-10">
            <div className="container">
                <div className="row justify-content-center">

                    {page && page?.filter(i => i.Identificador === props.page).map((item, index) => (

                        <div key={index} className="col-lg-10">

                            <div className="page-description__desc mb-7 mb-lg-9">
                                <p>
                                    <span dangerouslySetInnerHTML={renderObjectBody(item?.Descricao_x0020_Subtitulo)} />
                                </p>

                                <br />
                                <button onClick={() => RMA?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> PERFIS </button>
                                <button onClick={() => MAT?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> MAT VARIÁVEL/COTAS </button>
                                <button onClick={() => VITALICIO?.scrollIntoView()} className="btn btn-primary rounded py-1 px-5 mr-3 mb-3"> VITALÍCIO </button>
                            </div>
                            <div className="page-description__midias">
                                <PageDescriptionFootnote />
                            </div>

                        </div>

                    ))}{page == null &&
                        <div className="col-lg-10">

                            <div className="page-description__midias">
                                <PageDescriptionFootnote />
                            </div>

                        </div>

                    }
                </div>
            </div>
        </section>
    )
};
export default PageDescriptionPlano;
